import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SvgIconComponent } from '@dmb/core';

@Component({
  selector: 'dmb-card-header',
  templateUrl: './card-header.component.html',
  styleUrl: './card-header.component.scss',
  imports: [MatCardModule, MatTooltipModule, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent {
  readonly closeModal = output<void>();

  close() {
    this.closeModal.emit(undefined);
  }
}
